import React from "react";
import { Product } from "~/types/product";

type Props = {
  product: Product;
};

const ProductPrice: React.FC<Props> = ({ product }) => {
  const {
    whiteIsCheapest,
    startingPrice,
    calloutLabel,
    percentSavings,
    retailPrice,
  } = product;
  const displayWhiteStartsAt =
    whiteIsCheapest && !product.variants.some((variant) => variant.isCloseout);

  return (
    <div
      aria-label="Starts at"
      className="flex flex-row justify-center gap-x-8 lg:ml-1 lg:justify-start"
    >
      <div className="flex flex-col">
        <span
          data-testid="product-starts-at"
          className="text-sm uppercase text-black"
        >
          {displayWhiteStartsAt ? "Whites start at" : "Starts at"}
        </span>
        <span
          data-testid="product-starting-price"
          className="relative clear-left mb-2.5 w-full pr-8 text-[55px] leading-none text-green after:absolute after:-right-0.5 after:left-auto after:top-2 after:h-[42px] after:w-[4px] after:bg-white200 after:content-['']"
        >
          {startingPrice}
        </span>
        <span className="text-xs uppercase text-gray200">
          Prices vary based on color
        </span>
      </div>
      <div className="mt-[2px] flex flex-col gap-y-2.5">
        <span
          data-testid="product-callout-label"
          className={`min-h-[25px] text-[25px] leading-none text-red100 ${!product.calloutLabel ? "invisible" : ""}`}
        >
          {calloutLabel}
        </span>
        <span
          data-testid="product-percent-savings"
          className="text-sm font-bold leading-none text-black"
        >
          Save {percentSavings}
        </span>
        <span
          data-testid="product-retail-price"
          className="text-[18px] uppercase leading-[1rem] tracking-wider text-gray200"
        >
          Retail: {retailPrice}
        </span>
      </div>
    </div>
  );
};

export default ProductPrice;
